/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ExternalRole } from "./externalRole";

export enum ContractType {
  FIXED = "FIXED_TERM",
  INDEFINITE = "INDEFINITE",
}

export enum DurationType {
  FIXED = "FIXED_TERM",
  INDEFINITE = "INDEFINITE",
}

export type Contact = {
  comment: string | null;
  email: string;
  externalRoles: Array<ExternalRole>;
  id: string;
  name: string;
  phoneNumber: string | null;
  position: string;
  rulesOfEngagement: string | null;
};
